import { otmsHttp } from '@/utils/http/index.js'

/**
 * 获取订单列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9932
 */
 export function fetchOrderList(data, params) {
  return otmsHttp.request({
      url: '/unify/order/v2/page',
      method: 'post',
      data,
      params,
      noEnterprise:true
  })
}

/**
 * 获取仓合同
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/9838
 */
 export function getWareHouseContract(data) {
  return otmsHttp.request({
      url: '/bfs_pricing_rule/contract/all_type/list',
      method: 'post',
      data,
  })
}

/**
 * 取消订单
 * 
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9658
 */
 export function cancelOrder(data) {
  return otmsHttp.request({
      url: '/unify/order/v2/batch/cancel',
      method: 'post',
      data
  })
}